export default __webpack_public_path__ + "static/media/partial-refunds.02b35b28.svg";